import React, { useMemo } from "react";
import { ExpressionLineProps } from "../types";

import { findIndex } from "lodash";

const getSlotCount = (numbersCount: number) => {
  return numbersCount * 2 - 1
};

const breakDownExpression = (expression: string): string[] => {
  return [...expression].reduce<string[]>((res, char, i, arr) => {
    if (i > 0 && (res[res.length - 1] === "(" || char === ")")) {
      res[res.length - 1] += char;
    } else {
      res.push(char);
    }
    return res;
  }, []);
};

const ExpressionLine: React.FC<ExpressionLineProps> = ({
  lineNumber,
  currentActiveLineIndex,
  targetNumber,
  usedNumbers,
  expression,
  calculatedValue,  
  disabled,
  proximateSolution,
}) => {
  const displaySlots: string[] = useMemo(() => {
    const ret = breakDownExpression(expression);
    while (ret.length < getSlotCount(usedNumbers?.length || 0)) {
      ret.push("");
    }
    return ret;
  }, [expression, usedNumbers?.length]);
const isLineGuessed=lineNumber<currentActiveLineIndex
  const proximateSolutionDigits = proximateSolution
    ?.split("")
    .filter((c) => c.match(/\d/));

    const isCorrect=isLineGuessed? calculatedValue===targetNumber:undefined
    const slotColors:string[]=useMemo(()=>{
    // If the line is correct, all slots should be green
    
    let colors = Array(usedNumbers?.length || 0).fill("gray");
    if (!usedNumbers || usedNumbers.length === 0) {
      colors = Array(usedNumbers?.length || 0).fill("lightgray");
    }
    if (proximateSolution) {
      let useNumbersToIterate=[...usedNumbers??[]];
      let proximateSolutionDigitsToIterate=[...proximateSolutionDigits??[]];

    useNumbersToIterate.forEach((n,i)=>{    
      if (proximateSolutionDigits?.[i] === useNumbersToIterate[i]) {
        proximateSolutionDigitsToIterate[i]=" "
        useNumbersToIterate[i]=" "
        colors[i] = "green";
      }})
      useNumbersToIterate.forEach((n,i)=>{    
        if(n!==" ")
        { 
          const index=findIndex(proximateSolutionDigitsToIterate,ni=>ni===n)
          if(index!==-1){
            proximateSolutionDigitsToIterate[index]=" "
            colors[i] = "yellow";
          }
          }})
      }
        

        console.log(colors)
      
        return colors
  },[proximateSolution, proximateSolutionDigits, usedNumbers])

  return (
    <div className={`expression-line ${disabled ? "disabled" : ""}`}>
      <div className="expression-slots">
        {displaySlots.map((slot, index) => {
          if (index % 2 === 1) {
            return (
              <div key={index} className={`expression-slot operator-slot`}>
                <span className="slot-text">{slot}</span>
              </div>
            );
          } else {            
            return (
              <div
                key={index}
                className={`expression-slot number-slot ${slotColors[index/2]}`}

              >
                <span className="slot-text" >
                  {slot}
                </span>
              </div>
            );
          }
        })}
      </div>
      <div className="expression-result">=</div>
      <div
        className={`expression-value ${
          isCorrect === true
            ? "correct"
            : isCorrect === false
            ? "incorrect"
            : ""
        }`}
      >
        {calculatedValue ? Math.floor(calculatedValue * 100) / 100 : ""}
      </div>
    </div>
  );
};

export default ExpressionLine;
